// extracted by mini-css-extract-plugin
export default {"button":"downloadButton_button__HsCIG"};